import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { FaBell } from "react-icons/fa";
import "./NotificationBell.css";

const NotificationBell = () => {
  const [pausedNotification, setPausedNotification] = useState(null);
  const [pendingReviewNotification, setPendingReviewNotification] = useState(null);
  const [undocumentedNotification, setUndocumentedNotification] = useState(null);
  const [open, setOpen] = useState(false);
  const [nombreGet, setNombreGet] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedNombre = localStorage.getItem("nombre_get");
    if (!storedNombre) {
      console.log("No se encontró nombre_get en localStorage");
      return;
    }
    // Normalización para revisiones pendientes (con guiones bajos)
    const normalizedNombre = storedNombre.trim().toLowerCase().replace(" ", "_");
    // Normalización temporal para pausas (sin reemplazar espacios)
    const normalizedNombreForPaused = storedNombre.trim().toLowerCase();
    console.log("Nombre normalizado (revisiones):", normalizedNombre);
    console.log("Nombre normalizado (pausas):", normalizedNombreForPaused);
    setNombreGet(normalizedNombre);

    // Escuchar notificaciones de actividades pausadas (usando la normalización antigua)
    const pausedSummaryRef = doc(db, `notifications/${normalizedNombreForPaused}/summary/status`);
    console.log("Escuchando notificaciones pausadas en:", `notifications/${normalizedNombreForPaused}/summary/status`);
    const unsubPaused = onSnapshot(
      pausedSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de pausas recibida:", data);
          setPausedNotification(data);
        } else {
          console.log("No hay notificación de pausas activa");
          setPausedNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de pausas:", error);
      }
    );

    // Escuchar notificaciones de actividades pendientes de revisión (usando la normalización nueva)
    const pendingReviewSummaryRef = doc(db, `notifications/${normalizedNombre}/pending_reviews/status`);
    console.log("Escuchando notificaciones de revisiones en:", `notifications/${normalizedNombre}/pending_reviews/status`);
    const unsubPendingReview = onSnapshot(
      pendingReviewSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de revisiones recibida:", data);
          setPendingReviewNotification(data);
        } else {
          console.log("No hay notificación de revisiones activa");
          setPendingReviewNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de revisiones:", error);
      }
    );

    // Escuchar notificaciones de actividades sin documentar
    const undocumentedSummaryRef = doc(db, `notifications/${normalizedNombreForPaused}/undocumented/status`);
    console.log("Escuchando notificaciones de actividades sin documentar en:", `notifications/${normalizedNombreForPaused}/undocumented/status`);
    const unsubUndocumented = onSnapshot(
      undocumentedSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de actividades sin documentar recibida:", data);
          setUndocumentedNotification(data);
        } else {
          console.log("No hay notificación de actividades sin documentar activa");
          setUndocumentedNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de actividades sin documentar:", error);
      }
    );

    return () => {
      unsubPaused();
      unsubPendingReview();
      unsubUndocumented();
    };
  }, []);

  const handleGoToPaused = () => {
    navigate('/EnPausaSolicitante');
    setOpen(false);
  };

  const handleGoToPendingReviews = () => {
    navigate('/RevisarActividadSolicitante');
    setOpen(false);
  };

  const handleGoToUndocumented = () => {
    navigate('/EsperaDocumentos');
    setOpen(false);
  };

  if (!nombreGet) {
    return <div className="text-sm text-gray-600">Por favor, inicia sesión para ver notificaciones.</div>;
  }

  // Sumar los conteos de todas las notificaciones para el ícono de la campana
  const totalCount = (pausedNotification?.count || 0) + (pendingReviewNotification?.count || 0) + (undocumentedNotification?.count || 0);
  console.log("Total conteo de notificaciones:", totalCount, { pausedNotification, pendingReviewNotification, undocumentedNotification });

  return (
    <div className="notification-bell-container">
      <div
        className="bell-icon"
        onClick={() => setOpen((prev) => !prev)}
      >
        <FaBell size={24} />
        {totalCount > 0 && (
          <span className="notification-count">{totalCount}</span>
        )}
      </div>

      {open && (
        <div className="notification-dropdown">
          {pausedNotification || pendingReviewNotification || undocumentedNotification ? (
            <>
              {pausedNotification && (
                <div className="notification-item">
                  <p>{pausedNotification.message}</p>
                  <button onClick={handleGoToPaused}>Ir</button>
                </div>
              )}
              {pendingReviewNotification && (
                <div className="notification-item">
                  <p>{pendingReviewNotification.message}</p>
                  <button onClick={handleGoToPendingReviews}>Ir</button>
                </div>
              )}
              {undocumentedNotification && (
                <div className="notification-item">
                  <p>{undocumentedNotification.message}</p>
                  <button onClick={handleGoToUndocumented}>Ir</button>
                </div>
              )}
            </>
          ) : (
            <p className="text-sm text-gray-600 p-4 text-center">
              No hay nuevas notificaciones
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;